module.exports = __webpack_public_path__ + "static/assets/f39a81f3a288f7062ae9837762846c24.png";